import { setAllPersonaAccessData } from "./actions";

export const setPersonaAccessData = (personaAccessSettings) => (dispatch) => {
  if (personaAccessSettings)
    dispatch(setAllPersonaAccessData(personaAccessSettings));
};
